import {LOADING} from './types'

const loadingFetch = () =>({

    type: LOADING.FETCH

})

const loadingSuccess = () =>({

    type: LOADING.SUCCESS,

})

const loadingFinish = () =>({

    type: LOADING.FINISH,

})

const loadingFail = () =>({

    type: LOADING.FAIL,

})





export {loadingFetch, loadingFail, loadingSuccess, loadingFinish}